import { CacheDataRequest } from "./setting";
import { Filter, SortItem } from "./filtrable";

export class SecurityParam {
  CRUD: number;
  EnableAuthAction: boolean;
}

/**
 *Encapsula informacion de la respuesta recibida al ejecular los
 metodos getSubscription, getSettingSubscription y requerySubscription.
 *
 * @export
 * @class ResponseSetting
 */
export class ResponseSetting {
  FilterStorage = new Array<Filter>();
  CacheData: any;
  SecurityParam = new SecurityParam();
}

export interface IResponseAPI {
  DataSource: any;
  Commit: boolean;
  Message: string;
  TotalItems: number;
  HttpCode: number;
  Setting: ResponseSetting;
}

export class ResponseData implements IResponseAPI {
  DataSource: any;
  Commit: boolean;
  Message: string;
  TotalItems: number;
  HttpCode: number;
  Setting = new ResponseSetting();
}

export class Page {
  RowCount?: number;

  constructor(
    public Number = 1,
    public Size = 0,
    public VirtualPagination?: boolean
  ) {
    this.RowCount = 0;
  }
}

export interface IPageParameter {
  Page: Page;
  Filters?: Filter[];
  Sorts?: SortItem[];
}

export class PageParameter implements IPageParameter {
  Page = new Page();
  Filters? = new Array<Filter>();
  Sorts? = new Array<SortItem>();
}

export class RequestSetting implements IPageParameter {
  EnableFilter = true;
  LoadCRUD = true;
  Page = new Page();
  Filters? = new Array<Filter>();
  Sorts? = new Array<SortItem>();
  CacheDataProviders? = new Array<CacheDataRequest>();
  FilterText?: string;
  Data? = {};
}

export function objectIsResponseModel<T>(
  arg: ResponseData | T
): arg is ResponseData {
  return (<ResponseData>arg).DataSource !== undefined;
}
